import { api_GET, api_POST, api_PUT, api_DELETE } from "./_api.js";

const formulario_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Formulario")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListApp: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Formulario/GetListApp/" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListAtivosByFinalidade: (finalidade) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Formulario/GetListAtivosByFinalidade/${finalidade}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Formulario/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postFormulario: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Formulario/PostFormulario", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putFormulario: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Formulario/PutFormulario", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    postFormularioQuestao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Formulario/PostFormularioQuestao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItemFormularioQuestao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Formulario?formulario_id=" + id)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    putFormularioQuestao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Formulario/PutFormularioQuestao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    deleteFormularioQuestao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`Formulario/DeleteFormularioQuestao/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default formulario_api;
